import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpChipComponent } from './fcp-chip.component';

@NgModule({
    declarations: [FcpChipComponent],
    imports: [CommonModule],
    exports: [FcpChipComponent]
})
export class FcpChipModule {}
